import { render, staticRenderFns } from "./ImagePrefetch.vue?vue&type=template&id=39dcf817&scoped=true"
import script from "./ImagePrefetch.vue?vue&type=script&lang=js"
export * from "./ImagePrefetch.vue?vue&type=script&lang=js"
import style0 from "./ImagePrefetch.vue?vue&type=style&index=0&id=39dcf817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcf817",
  null
  
)

export default component.exports